import React from 'react';
import {Layout, Spin} from "antd";
import {Content} from "antd/es/layout/layout";
import { LoadingOutlined } from '@ant-design/icons';

const Authenticating: React.FC<any> = () => {
    const loadingIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />;

    return (
        <Layout style={{ minHeight: '100vh' }}>
            <Content style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <Spin tip="Authenticating" indicator={loadingIcon}>
                    <div style={{ padding: '50px 100px', background: 'rgba(0, 0, 0, 0.05)', borderRadius: '4px' }} className="content" />
                </Spin>
            </Content>
        </Layout>
    )
}

export default Authenticating;